import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Swedish Personnummer generator following Single Responsibility Principle
 */
export class PersonnummerGenerator extends BaseGenerator {
  generate(options = {}) {
    const { formatted = true, birthYear = null } = options;

    // Generate birth date
    const year = birthYear ? birthYear.toString().slice(-2) : this.padZero(this.randomInt(0, 99), 2);
    const month = this.padZero(this.randomInt(1, 12), 2);
    const day = this.padZero(this.randomInt(1, 28), 2);

    // Generate birth number (3 digits)
    const birthNumber = this.randomDigits(3);

    // Calculate check digit using Luhn algorithm
    const partial = year + month + day + birthNumber;
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      let digit = parseInt(partial[i]);
      
      if (i % 2 === 1) {
        digit *= 2;
        if (digit > 9) {
          digit = Math.floor(digit / 10) + (digit % 10);
        }
      }
      
      sum += digit;
    }

    const checkDigit = (10 - (sum % 10)) % 10;
    const personnummer = partial + checkDigit;

    return formatted ? 
      `${personnummer.substring(0, 6)}-${personnummer.substring(6, 10)}` : 
      personnummer;
  }
}